import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { unwrap } from "@majourneys/api-client";
import { useBookingContext } from "../provider";

export const activityKeys = {
  all: ["activities"] as const,
  detail: (slug: string, lang?: string) =>
    [...activityKeys.all, "detail", slug, lang ?? "en"] as const,
};

export function useActivity(slug: string) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const { api } = useBookingContext();
  return useSuspenseQuery({
    queryKey: activityKeys.detail(slug, lang),
    queryFn: async () =>
      unwrap(await api.activities.explore({ slug }).get({ query: lang ? { lang } : {} })),
  });
}
